module.exports = __webpack_public_path__ + "img/9791185306223.e5cd01b0.jpg";